import template from './template.html';

controller.$inject = ['$state','adalAuthenticationService'];

export function controller($state, adalAuthenticationService) {
    const vm = this;
    vm.proceed = proceed;
    vm.store = {};
    vm.user = adalAuthenticationService.userInfo;

    function proceed() {
        if (vm.store && vm.store.storeId) {
            $state.go('schedules', {
                storeId: vm.store.storeId
            });
        }
    }
}

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider.state('storeselector', {
        controller: controller,
        controllerAs: 'vm',
        parent: 'guest',
        template: template,
        url: 'storeselector',
        requireADLogin: true
    });
}

export default config;



// WEBPACK FOOTER //
// ./src/js/components/guest/storeselector/index.js